import { IItem } from "../types";

export const hobbies: IItem[] = [
  {
    description: "playing badminton",
    emoji: "🏸",
  },
  {
    description: "trying new recipes",
    emoji: "👨‍🍳",
  },
  {
    description: "dilly dallying around NYC",
    emoji: "🗽",
  },
  {
    description: "making YouTube videos",
    emoji: "▶️",
  },
];
